// タブ: [data-mp-tabs] > [role=tablist] > button[role=tab][aria-controls] ＋ [role=tabpanel]
// 選択中のタブだけ aria-selected="true" / tabindex=0 にし、対応するパネル以外に hidden を付ける。
// ←→ / Home / End でタブを移動する（WAI-ARIA の自動選択型）。切り替えたら root に mp:tabchange を発火する。

export function setupTabs() {
  document.querySelectorAll('[data-mp-tabs]').forEach((root) => {
    const tabs = [...root.querySelectorAll('[role="tab"]')];
    if (!tabs.length) return;

    const select = (tab, focus) => {
      tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
        const panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
      root.dispatchEvent(new CustomEvent('mp:tabchange', { detail: { tab } }));
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(tab, false));
      tab.addEventListener('keydown', (event) => {
        const next = { ArrowRight: index + 1, ArrowLeft: index - 1, Home: 0, End: tabs.length - 1 }[event.key];
        if (next === undefined) return;
        event.preventDefault();
        select(tabs[(next + tabs.length) % tabs.length], true);
      });
    });
  });
}
